import { sortBy } from "lodash";
import { PRD_URL, WS_URL } from "../../config/connection";
import { mapObject } from "../../helpers/commonHelpers";
import {
	CLOSE_GAME_MESSAGE,
	GO_BACK_TO_MAIN,
	RESET_CLIENT,
	SAVE_USER_DETAILS,
	UPDATE_SEARCHED_USERS_LIST,
} from "../actions/actionTypes";
import {
	CLEAR_QUERIED_USERS,
	CLOSE_COMPOSE_MESSAGE,
	CLOSE_MESSAGE_DETAILS,
	OPEN_COMPOSE_MESSAGE,
	OPEN_MESSAGE_DETAILS,
	OPEN_MESSAGE_INBOX,
	RECEIVE_NEW_MESSAGE,
	SAVE_MESSAGE_LIST,
	TOGGLE_CHECK_MESSAGE,
	UPDATE_MESSAGE_DETAILS,
} from "../actionTypes";

const initialState = {
	isInboxOpened: false,
	isComposeOpened: false,
	forwardMessage: false,
	openedForReply: false,
	isDirectMessage: false,
	isReadMessageOpened: false,
	unreadMessageCounter: 0,
	selectedMessage: {
		fromUsername: "test_4",
		fromUserID: WS_URL == PRD_URL ? "28548" : "20000206",
		subject: "Very long message",
		recieveTimestamp: 1635256638,
		isUnread: false,
		isFromSystem: false,
		content:
			"Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\nTest message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1 Test message 1\n",
	},
	messages: [],
	queriedUsers: [],
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case SAVE_USER_DETAILS:
			if (!payload || typeof payload.unreadMessageCnt === "undefined") return state;
			return { ...state, unreadMessageCounter: payload.unreadMessageCnt };
		case RECEIVE_NEW_MESSAGE:
			if (!payload || payload.type !== "newMessage") return state;
			return { ...state, unreadMessageCounter: state.unreadMessageCounter + 1 };
		case CLEAR_QUERIED_USERS:
			return { ...state, queriedUsers: [] };
		case UPDATE_SEARCHED_USERS_LIST:
			if (!payload || !payload.users || typeof payload.users !== "object" || Object.keys(payload.users).length == 0)
				return state;
			var newQueriedUsers = [];
			mapObject(payload.users, (key, val) => {
				newQueriedUsers.push({ userID: key, uName: val });
			});
			return { ...state, queriedUsers: newQueriedUsers };
		case SAVE_MESSAGE_LIST:
			if (!payload || !payload.messages || !Array.isArray(payload.messages)) return state;
			var newMessages = [];
			payload.messages.forEach((msg) =>
				newMessages.push({
					messageID: msg.messageID,
					fromUsername: typeof msg.fromUsername === "string" ? msg.fromUsername : " ",
					fromUserID: typeof msg.fromUserID !== "undefined" ? msg.fromUserID : "-1",
					subject: typeof msg.subject === "string" ? msg.subject : " ",
					message: typeof msg.message === "string" ? msg.message : " ",
					isUnread: typeof msg.isUnread === "boolean" ? msg.isUnread : false,
					isFromSystem: typeof msg.isFromSystem === "boolean" ? msg.isFromSystem : false,
					recieveTimestamp: typeof msg.recieveTimestamp === "number" ? msg.recieveTimestamp : 0,
				})
			);
			newMessages = sortBy(newMessages, (m) => m.recieveTimestamp).reverse();
			var countUnread = newMessages.filter((m) => m.isUnread).length;
			return {
				...state,
				messages: newMessages,
				unreadMessageCounter: countUnread,
			};
		case OPEN_MESSAGE_INBOX:
			return { ...state, isInboxOpened: true, queriedUsers: [] };
		case CLOSE_GAME_MESSAGE:
			return {
				...state,
				isInboxOpened: false,
				isComposeOpened: false,
				isReadMessageOpened: false,
			};
		case OPEN_COMPOSE_MESSAGE:
			const _isDirectMessage = payload && payload.selectedUser && typeof payload.selectedUser.userID === "string";
			return {
				...state,
				isComposeOpened: true,
				isDirectMessage: _isDirectMessage,
				forwardMessage: payload && payload.isForwarded && state.selectedMessage != null,
				openedForReply: payload && payload.isReply && state.selectedMessage != null,
				queriedUsers: _isDirectMessage
					? [
							{
								userID: payload.selectedUser.userID,
								uName: payload.selectedUser.username,
							},
					  ]
					: [],
			};
		case CLOSE_COMPOSE_MESSAGE:
			return {
				...state,
				isComposeOpened: false,
				forwardMessage: false,
				openedForReply: false,
				isDirectMessage: false,
				queriedUsers: [],
			};
		case TOGGLE_CHECK_MESSAGE:
			if (!payload || typeof payload.messageID === undefined) return state;
			const foundMsgIndex = state.messages.findIndex((msg) => msg.messageID == payload.messageID);
			if (foundMsgIndex == -1) return state;
			var newMessages = [...state.messages];
			var foundMsg = newMessages[foundMsgIndex];
			foundMsg.isSelected = !foundMsg.isSelected;
			return { ...state, messages: newMessages };
		case OPEN_MESSAGE_DETAILS:
			return { ...state, isReadMessageOpened: true };
		case UPDATE_MESSAGE_DETAILS:
			if (!payload || !payload.message || !payload.message.content) return state;
			return { ...state, selectedMessage: payload.message };
		case CLOSE_MESSAGE_DETAILS:
			return {
				...state,
				isReadMessageOpened: false,
				selectedMessage: initialState.selectedMessage,
			};
		case GO_BACK_TO_MAIN:
		case RESET_CLIENT:
			return initialState;
		default:
			return state;
	}
};
